import styled from 'styled-components';
import JoulepointLogo from '../assets/companyLogo/jplogo.png';

const Logo = styled((p) => (
  <img src={JoulepointLogo} alt="JoulePoint" {...p} />
))`
  width: 100%;
  max-width: 200px;
  width: ${(props) => props.width || 'auto'};
  height: ${(props) => props.height || 'auto'};
`;

export default Logo;
